import { RootState } from "@app/store"
import { LocationIp } from "./types";

export const selectCurrentLocation = (state: RootState): LocationIp | undefined => state.location.currentPosition
export const selectLastLocation  =  (state: RootState): LocationIp   => state.location.lastPosition